import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
import CloseIcon from "@mui/icons-material/Close";

// import JS files

import useFetch from "../../../../context/useFetch";
import MuiTextFieldHook from "../../../shares/MuiTextFieldHook";
import MuiModal from "../../../shares/MuiModal";
import MuiUpload from "../../../shares/MuiUpload";
import MuiButton from "../../../shares/MuiButton";
import { fixNumbers } from "../../../../utils";
import MuiComboBox from "../../../shares/MuiComboBox";

// import Others files
import sampleImg from "../../../../imgs/customerAvatar.png";
import EmployeeChangePassModal from "./EmployeeChangePassModal";

const EditEmployee = (props) => {
  const [openChangePassCustomerModal, setOpenChangePassCustomerModal] =
    useState(false);
  const handleChangePassCustomerModal = () => {
    setOpenChangePassCustomerModal((before) => !before);
  };

  const [postData, setPostData] = useState({});
  const [userPic, setUserPic] = useState(undefined);
  const [disableBtn, setDisableBtn] = useState(true);
  const [imgUrl, setImgUrl] = useState(sampleImg);
  const [id, seId] = useState(props.userId);
  const [adminCityList, setAdminCityList] = useState({ results: [] });
  const [selectedCity, setSelectedCity] = useState(undefined);
  const [searchedCityText, setSearchedCityText] = useState("");

  const {
    register,
    handleSubmit,
    watch,
    setError,
    control,
    formState: { errors },
    reset,
  } = useForm({
    defaultValues: {
      name: props.name,
      address: props.address,
      phone_number: props.phone_number,
      phone: props.phone,
      city: props.city,
      email: props.email,
      store_name: props.store_name,
      attach_file: props.attach_file,
      username: props.user,
      password: "***********",
    },
  });

  const EditCustomerApi = useFetch({
    method: "patch",
    url: `Customer_Service/${id}`,

    trigger: false,
    data: postData,
    caller: props.getFunc,
    argFunc: (res) => {
      reset();
      setUserPic({});
      setDisableBtn(true);
      setImgUrl(sampleImg);

      // toast.success("با موفقیت ویرایش شد", {
      //   position: toast.POSITION.TOP_CENTER,
      // });
      props.setOpenModal(false);
    },
    errMessage: (mess) => {
      toast.error("خطایی رخ داده است", {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });

  const onSubmit = (data) => {
    if (userPic !== undefined) {
      data["img"] = userPic;
    }
    const formData = new FormData();

    formData.append("user", data.username);
    formData.append("password", data.password);
    formData.append("name", data.name);
    formData.append("phone_number", fixNumbers(data.phone_number));
    formData.append("store_name", data.store_name);

    formData.append("email", data.email);
    formData.append(
      "city",
      adminCityList.results.length > 0
        ? adminCityList.results.filter((it) => it.id == selectedCity)[0].name
        : ""
    );
    formData.append("phone", fixNumbers(data.phone));
    formData.append("address", data.address);

    if (userPic !== undefined) {
      formData.append("attach_file", userPic, userPic.name);
    }

    setPostData(formData);
    EditCustomerApi.reFetch("post");
  };

  useEffect(() => {
    if (userPic instanceof File) {
      setImgUrl(URL.createObjectURL(userPic));
    }
  }, [userPic]);

  const handleSearchedCityText = (text) => {
    setSearchedCityText(text);
    if (text.length >= 1) {
      getListOfCityApi.reFetch();
    }
  };

  const getListOfCityApi = useFetch({
    method: "get",
    url: "City_Service",
    params: { name: searchedCityText },
    argFunc: (res) => {
      setAdminCityList(res);
    },
    errMessage: (mess) => {
      toast.error("خطایی رخ داده است", {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });

  return (
    <>
      {openChangePassCustomerModal && (
        <EmployeeChangePassModal
          openModal={openChangePassCustomerModal}
          setOpenModal={setOpenChangePassCustomerModal}
          getFunc={props.getFunc}
          name={props.name}
          user={props.user}
        />
      )}
      <MuiModal
        openModal={props.openModal}
        setOpenModal={props.setOpenModal}
        width="w-11/12"
        isOverflow={true}
        isNotBackdropClick={true}
      >
        <div>
          <div className="close-modal-icon">
            <CloseIcon
              onClick={() => props.setOpenModal(false)}
              fontSize="large"
              color="secondary"
            />
          </div>
          <form className="" onSubmit={handleSubmit(onSubmit)}>
            <div className="grid md:grid-cols-3 gap-y-6 gap-x-4 mt-6">
              <div className="">
                <div className="mt-2 flex justify-center">
                  {userPic instanceof File ? (
                    <img
                      className="w-20 h-20 md:w-40 md:h-40 rounded-full"
                      src={URL.createObjectURL(userPic)}
                    />
                  ) : props.attach_file == "EMPTY" ? (
                    <img
                      className="w-20 h-20 md:w-40 md:h-40 rounded-full"
                      src={sampleImg}
                    />
                  ) : (
                    <img
                      className="w-20 h-20 md:w-40 md:h-40 rounded-full"
                      src={props.attach_file}
                    />
                  )}
                </div>
                <div className="mt-4">
                  <MuiUpload setImageFile={setUserPic} />
                </div>
                <div className="mt-6">
                  <MuiTextFieldHook
                    id="outlined-basic"
                    label="نام کاربری "
                    variant="outlined"
                    size="small"
                    name="username"
                    isLTR={true}
                    control={control}
                    register={{
                      required: {
                        value: true,
                        message: "نام کاربری را وارد کنید",
                      },
                    }}
                  />
                </div>
                <div className="mt-6">
                  <MuiTextFieldHook
                    id="outlined-basic"
                    label="رمز عبور"
                    variant="outlined"
                    size="small"
                    name="password"
                    isLTR={true}
                    isdisabled={true}
                    control={control}
                    register={{
                      required: {
                        value: true,
                        message: "رمز عبور را وارد کنید",
                      },
                    }}
                  />
                </div>
              </div>
              <div className="md:mt-8">
                <div className="mt-6">
                  <MuiTextFieldHook
                    id="outlined-basic"
                    variant="outlined"
                    size="small"
                    label="نام و نام‌خانوادگی"
                    name="name"
                    control={control}
                    register={{
                      required: {
                        value: true,
                        message: "نام و نام خانوادگی را وارد کنید",
                      },
                    }}
                  />
                </div>
                <div className="mt-6">
                  <MuiTextFieldHook
                    id="outlined-basic"
                    variant="outlined"
                    size="small"
                    label="شماره همراه"
                    name="phone_number"
                    isLTR={true}
                    control={control}
                    register={{
                      required: {
                        value: true,
                        message: "شماره تلفن همراه را وارد کنید",
                      },
                      // pattern: {
                      //   value: /[0-9]{11}/,
                      //   message: "شماره تلفن باید 11 رقمی باشد",
                      // },
                    }}
                  />
                </div>
                {/* <div className="mt-6">
                  <MuiTextFieldHook
                    id="outlined-basic"
                    variant="outlined"
                    size="small"
                    label="نام فروشگاه"
                    name="store_name"
                    control={control}
                    register={{
                      required: {
                        value: true,
                        message: "نام فروشگاه  را وارد کنید",
                      },
                    }}
                  />
                </div> */}
                <div className="mt-6">
                  <MuiTextFieldHook
                    id="outlined-basic"
                    variant="outlined"
                    size="small"
                    label="ایمیل"
                    name="email"
                    control={control}
                    register={{
                      // required: {
                      //   value: true,
                      //   message: "ایمیل را وارد کنید",
                      // },
                      pattern: {
                        value:
                          /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/,
                        message: "فرمت ایمیل وارد شده صحیح نمی باشد",
                      },
                    }}
                  />
                </div>

                <div className="mt-6">
                  <MuiComboBox
                    size="small"
                    label="شهر"
                    forUser
                    name="city"
                    labelId="city-search-label"
                    id="city-search-select"
                    options={adminCityList.results}
                    placeholder="شهر"
                    setSelectedOption={setSelectedCity}
                    setSearchText={handleSearchedCityText}
                  />
                </div>
              </div>
              <div className="md:mt-8">
                <div className="mt-6">
                  <MuiTextFieldHook
                    id="outlined-basic"
                    variant="outlined"
                    size="small"
                    label="تلفن ثابت"
                    name="phone"
                    isLTR={true}
                    control={control}
                    // register={{
                    //   required: {
                    //     value: true,
                    //     message: "تلفن ثابت را وارد کنید",
                    //   },
                    // }}
                  />
                </div>
                <div className="mt-6">
                  <MuiTextFieldHook
                    id="outlined-basic"
                    variant="outlined"
                    size="small"
                    label="آدرس"
                    name="address"
                    control={control}
                    // register={{
                    //   required: {
                    //     value: true,
                    //     message: "آدرس را وارد کنید",
                    //   },
                    // }}
                  />
                </div>
              </div>
            </div>
            <div className="text-left w-full mt-2">
              <MuiButton
                withoutOnClick
                type="submit"
                variant="contained"
                //     icon={<AddIcon />}
                color="success"
                text="ویرایش"
                disabled={EditCustomerApi.loading}
              />
            </div>
          </form>
          <div className="border-b border-dashed mt-4"></div>
          <div className="flex justify-between items-center mt-2">
            <span className="text-sm">
              برای تغییر رمز عبور کاربر روی دکمه تغییر رمزعبور کلیک کنید.
            </span>
            <MuiButton
              onClick={handleChangePassCustomerModal}
              variant="outlined"
              // icon={<AddIcon />}
              color="primary"
              text="تغییر رمز عبور"
            />
          </div>
        </div>
      </MuiModal>
    </>
  );
};

export default EditEmployee;
